import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-5 pb-5 container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_ds_header = _resolveComponent("ds-header")!
  const _component_Qalendar = _resolveComponent("Qalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_ds_header, {
      title: _ctx.$t('schedule.title'),
      hasButton: false
    }, null, 8, ["title"]),
    _createVNode(_component_Qalendar, {
      class: "px-5 pb-5 container",
      events: _ctx.schedules,
      config: _ctx.config,
      onEditEvent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEvent($event))),
      onDeleteEvent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDelete($event))),
      onUpdatedPeriod: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getRange($event))),
      onUpdatedMode: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getRangeMode($event)))
    }, null, 8, ["events", "config"])
  ]))
}